import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  login: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: { 
    isLoggedIn: (state, action) => {
      state.login = action.payload
      // localStorage.setItem('login',action.payload)
    },
    logOut: (state, action) => {
      state.login = false
    },
  }, 
})

// Action creators are generated for each case reducer function
export const { isLoggedIn ,logOut} = userSlice.actions

export default userSlice.reducer